__turbopack_context__.v({
  "collapsibleIcon": "MpyxGG_collapsibleIcon",
  "condensed": "MpyxGG_condensed",
  "firstName": "MpyxGG_firstName",
  "icon": "MpyxGG_icon",
  "link": "MpyxGG_link",
  "points": "MpyxGG_points",
  "pointsPulse": "MpyxGG_pointsPulse",
});
